/**
 * 📦 V2 Affiliates API client
 * Rotas /api/v2/affiliates (vínculos afiliado × produto/plano)
 * Spec: docs/V2/07_REGRAS_NEGOCIO.md §19.2 (afiliação granular)
 */

import v2Api from './index';

export const affiliatesV2API = {
  /**
   * Produtor convida afiliado.
   * Body: { product_id, user_id, plan_id?, commission_value_override? }
   * planId NULL = vínculo no produto inteiro (default).
   */
  create: (data) => v2Api.post('/affiliates', data),

  /**
   * Convida afiliado por EMAIL. Backend cria user shell se necessário e
   * dispara email de convite (best-effort).
   * Body: { product_id, email, commission_value_override? }
   */
  invite: (data) => v2Api.post('/affiliates/invite', data),

  /** Lista vínculos de um produto. */
  listByProduct: (productId) => v2Api.get(`/affiliates/by-product/${productId}`),

  /** Lista vínculos do user autenticado (painel "Meus Links" §19.3). */
  listMine: () => v2Api.get('/affiliates/me'),

  /**
   * Lista todos afiliados em qualquer produto do user autenticado
   * (painel "Meus Afiliados" do produtor).
   */
  listOfMyProducts: () => v2Api.get('/affiliates/of-my-products'),

  findById: (id) => v2Api.get(`/affiliates/${id}`),

  approve: (id) => v2Api.post(`/affiliates/${id}/approve`),

  /** body: { reason } */
  reject: (id, data) => v2Api.post(`/affiliates/${id}/reject`, data),

  suspend: (id) => v2Api.post(`/affiliates/${id}/suspend`),

  /** body: { commission_value_override } */
  updateCommissionOverride: (id, data) =>
    v2Api.patch(`/affiliates/${id}/commission-override`, data),

  remove: (id) => v2Api.delete(`/affiliates/${id}`),
};

export default affiliatesV2API;
